import AppStorage from "@/lib/appStorage";

export const NSFW_USER_SETTING = "NSFW_USER_SETTING";

// cookie (not localStorage) so SSR and nginx cache can see the answer of 18+ entry gate
export const NSFW_AGE_GATE_COOKIE = "nsfw_age_gate";

// where the 18+ entry gate sends visitors who answered "Exit"
export const NSFW_AGE_GATE_EXIT_URL = "https://www.google.com";

export enum NSFW_AGE_GATE {
  PASSED = "1",
  DECLINED = "0",
}

// "Enter" is remembered for 30 days, "Exit" for 1 day: blocks coming back, but does not lock out an adult forever
const NSFW_AGE_GATE_MAX_AGE = {
  [NSFW_AGE_GATE.PASSED]: 30 * 24 * 60 * 60,
  [NSFW_AGE_GATE.DECLINED]: 24 * 60 * 60,
};

export const getStorageNSFWUserSettings = () => {
  const value = AppStorage.getNumber(NSFW_USER_SETTING, -1);
  return value === -1 ? null : Boolean(value);
};

export const setNSFWUserSettings = (value: boolean) => {
  AppStorage.setNumber(NSFW_USER_SETTING, Number(value));
};

export const getNsfwAgeGateCookie = (cookie: string = typeof document !== "undefined" ? document.cookie : "") => {
  const match = cookie.match(new RegExp(`(?:^|;\\s*)${NSFW_AGE_GATE_COOKIE}=([^;]*)`));
  const value = match ? match[1] : null;
  return value === NSFW_AGE_GATE.PASSED || value === NSFW_AGE_GATE.DECLINED ? (value as NSFW_AGE_GATE) : null;
};

export const setNsfwAgeGateCookie = (value: NSFW_AGE_GATE) => {
  const secure = location.protocol === "https:" ? "; Secure" : "";
  document.cookie = `${NSFW_AGE_GATE_COOKIE}=${value}; path=/; max-age=${NSFW_AGE_GATE_MAX_AGE[value]}; SameSite=Lax${secure}`;
};

export const leaveSite = () => {
  location.replace(NSFW_AGE_GATE_EXIT_URL);
};
